import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getBreakpoints } from 'skrit-web-framework/utils';
import Drawer from 'skrit-web-framework/components/Drawer';
import translate from 'skrit-web-framework/translator';
import withSizes from 'react-sizes';
import cls from 'classnames';

import Notifications from './Notifications';
import NotificationButton from './NotificationButton';
import Svg from 'skrit-web-framework/components/Svg';

const mapStateToProps = state => {
    const alerts = state.config.NumAlertas;
    return {
        collapsed: state.menuLateral.open,
        menus: state.config.menus || [],
        theme: state.config.theme || {},
        usuario: state.config.NombreUsuario,
        alerts: alerts || 0
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleSidebar() {
            dispatch({ type: 'TOGGLE_MENU_LATERAL' });
        }
    };
};

const SIDEBAR_WIDTH = window.outerWidth * 0.8;

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: 2,
            menus: this.orderMenus(props.menus),
            position: -SIDEBAR_WIDTH,
            startX: 0,
            curX: 0,
            moving: false,
            drawer: false,
            profileMenu: false,
            notifications: false
        };
    }

    componentDidMount() {
        this.addEvents();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.collapsed !== this.props.collapsed) {
            this.handleCollapse(this.props.collapsed);
        }
        if (prevProps.isDesktop !== this.props.isDesktop) {
            this.handleEvents(this.props.isDesktop);
        }
        if (prevProps.menus !== this.props.menus) {
            this.handleMenuOrder(this.props.menus);
        }
    }

    handleCollapse(isCollapsed) {
        this.setState({ position: isCollapsed ? -SIDEBAR_WIDTH : 0 });
    }

    handleEvents(isDesktop) {
        if (isDesktop) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    handleMenuOrder(menus) {
        this.setState({ menus: this.orderMenus(menus) });
    }

    addEvents() {
        document.addEventListener('touchstart', this.onTouchStart);
        document.addEventListener('touchmove', this.onTouchMove);
        document.addEventListener('touchend', this.onTouchEnd);
        document.addEventListener('click', this.handleClickOutside);
    }

    removeEvents() {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('click', this.handleClickOutside);
    }

    onTouchStart = e => {
        const posX = e.touches[0].clientX;
        const drawer = this.sidebar.getElementsByClassName('drawer');
        const isOnDrawer = this.state.drawer && drawer[0].contains(e.target);

        if (
            isOnDrawer ||
            (this.state.position === -SIDEBAR_WIDTH &&
                posX > window.outerWidth * 0.1)
        ) {
            this.setState({ cancelled: true });
        } else {
            this.setState({
                startX: posX,
                curX: posX,
                moving: true
            });
        }
    };

    onTouchMove = e => {
        if (!this.state.cancelled) {
            const posX = e.touches[0].clientX;
            this.setState({
                position: -SIDEBAR_WIDTH + Math.min(posX, SIDEBAR_WIDTH),
                curX: posX
            });
        }
    };

    onTouchEnd = () => {
        const { startX, curX, cancelled } = this.state;
        if (cancelled) {
            this.setState({ cancelled: false });
        } else if (startX !== curX) {
            let position = 0;
            if (startX > curX) {
                position = -SIDEBAR_WIDTH;
            }
            this.setState({
                position: position,
                startX: 0,
                curX: 0,
                moving: false
            });
        }
    };

    handleClickOutside = e => {
        if (
            this.props.collapsed &&
            !this.props.isDesktop &&
            !this.sidebar.contains(e.target)
        ) {
            this.props.toggleSidebar();
        }
    };

    handleDrawer = id => () => {
        if (this.state.activeMenu === id && this.state.drawer) {
            this.setState({ drawer: false });
        } else {
            this.setState({
                activeMenu: id,
                drawer: true,
                notifications: false,
                profileMenu: false
            });
        }
    };

    handleCloseDrawer = key => () => {
        this.setState({ [key]: false });
    };

    handleLink = () => {
        this.setState({
            profileMenu: false,
            drawer: false,
            notifications: false,
            position: -SIDEBAR_WIDTH
        });
    };

    orderMenus(menus) {
        return menus
            .map(e => {
                if (e.menusHijos && e.menusHijos.length > 0) {
                    return {
                        ...e,
                        menusHijos: this.orderMenus(e.menusHijos)
                    };
                }
                return e;
            })
            .sort((a, b) => a.Orden - b.Orden);
    }

    handleProfileMenu = () => {
        this.setState({
            profileMenu: !this.state.profileMenu,
            drawer: false,
            notifications: false
        });
    };

    toggleNotifications = () => {
        this.setState({ notifications: !this.state.notifications });
    };

    toggleFullScreen = () => {
        let fullScreen =
            document.fullScreenElement ||
            document.mozFullScreen ||
            document.webkitIsFullScreen ||
            document.msFullscreenElement;
        if (fullScreen) {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        } else if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(
                Element.ALLOW_KEYBOARD_INPUT
            );
        }
    };

    renderHeader() {
        return (
            <Link to='/' onClick={this.handleLink}>
                <div className='header'>
                    <div className='logo'>
                        <Svg
                            src='/Styles/img/logo-motoscat-white.svg'
                            class='svg'
                        />
                    </div>
                    <div className='marca'>Back Office</div>
                </div>
            </Link>
        );
    }

    renderProfile() {
        const { usuario } = this.props;
        const { profileMenu } = this.state;
        const classObj = { active: profileMenu, closed: !profileMenu };
        return (
            <Fragment>
                <div
                    className={cls('profile', classObj)}
                    onClick={this.handleProfileMenu}
                >
                    <div className='logo'>
                        <i className='ms-Icon ms-Icon--Contact' />
                    </div>
                    <div className='name'>{usuario}</div>
                    <div className='empresa'>Motoscat</div>
                </div>
                {this.renderProfileMenu(classObj)}
            </Fragment>
        );
    }

    renderProfileMenu(classObj) {
        return (
            <div className={cls('profile-menu', classObj)}>
                <Link to='/perfil' className='btn' onClick={this.handleLink}>
                    <i className='ms-Icon ms-Icon--Shield icon' />
                    <div className='text'>{translate('mi_configuracion')}</div>
                </Link>
                <Link to='/usuarios' className='btn' onClick={this.handleClick}>
                    <i className='ms-Icon ms-Icon--Group icon' />
                    <div className='text'>{translate('otros_usuarios')}</div>
                </Link>
                <Link to='/logout' className='btn' onClick={this.handleLink}>
                    <i className='ms-Icon ms-Icon--ReturnToSession icon' />
                    <div className='text'>{translate('salir')}</div>
                </Link>
            </div>
        );
    }

    renderStatus() {
        return (
            <div className='sidebar-notifications'>
                <NotificationButton
                    icon='ms-Icon ms-Icon--Ringer'
                    label={translate('alertas')}
                    counter={this.props.alerts}
                    onClick={this.toggleNotifications}
                />
                {/* <button className='btn' onClick={this.toggleNotifications}>
                    <div>
                        <i className='ms-Icon ms-Icon--Headset' />
                        <span className='custom-badge'>2</span>
                    </div>
                    <span className='text'>Soporte</span>
                </button>
                <button className='btn' onClick={this.toggleNotifications}>
                    <div>
                        <i className='ms-Icon ms-Icon--Mail' />
                        <span className='custom-badge'>4</span>
                    </div>
                    <span className='text'>Correo</span>
                </button> */}
            </div>
        );
    }

    renderMenu() {
        const { menus, drawer, activeMenu } = this.state;
        return (
            <ul className='nav'>
                {menus.map(e => {
                    if (e.menusHijos.length === 0) {
                        if (e.Link && e.ruta !== '')
                            return (
                                <li
                                    key={e.id}
                                    className={cls({
                                        active: drawer && e.id === activeMenu
                                    })}
                                >
                                    {this.getLink(e)}
                                </li>
                            );
                        return (
                            <li key={e.id} className='separator'>
                                {e.Descripcion}
                            </li>
                        );
                    }
                    return (
                        <li
                            key={e.id}
                            className={cls({
                                active: drawer && e.id === activeMenu
                            })}
                        >
                            {e.menusHijos.length > 0
                                ? this.getChevron(e)
                                : this.getLink(e)}
                        </li>
                    );
                })}
            </ul>
        );
    }

    getChevron(e) {
        return (
            <button className='btn' onClick={this.handleDrawer(e.id)}>
                <i
                    className={`ms-Icon ms-Icon--${e.img ||
                        'DefectSolid'} icon`}
                />
                <div className='text'>
                    <span>{e.Descripcion}</span>
                    <i className='ms-Icon ms-Icon--ChevronRight ml-auto' />
                </div>
            </button>
        );
    }

    getLink(e) {
        return (
            <Link to={e.Link} className='btn' onClick={this.handleLink}>
                <i
                    className={`ms-Icon ms-Icon--${e.img ||
                        'DefectSolid'} icon`}
                />
                <div className='text'>
                    <div>{e.Descripcion}</div>
                    <div className='description'>{e.Descripcion_txt}</div>
                </div>
            </Link>
        );
    }

    renderVersion() {
        return (
            <div className='sidebar-version'>
                <Link to='/versiones'>
                    <span>Versión {process.env.VERSION}</span>
                </Link>
            </div>
        );
    }

    renderFooter() {
        return (
            <div className='sidebar-footer'>
                <div>
                    <button className='btn' onClick={this.toggleFullScreen}>
                        <i className='ms-Icon ms-Icon--FullScreen' />
                    </button>
                    <Link
                        to='/agenda'
                        className='btn'
                        onClick={this.handleLink}
                    >
                        <i className='ms-Icon ms-Icon--DateTime2' />
                    </Link>
                    <Link
                        to='/contactos'
                        className='btn'
                        onClick={this.handleLink}
                    >
                        <i className='ms-Icon ms-Icon--Phone' />
                    </Link>
                    <Link
                        to='/logout'
                        className='btn'
                        onClick={this.handleLink}
                    >
                        <i className='ms-Icon ms-Icon--ReturnToSession' />
                    </Link>
                </div>
            </div>
        );
    }

    renderNotifications() {
        return (
            <Notifications
                open={this.state.notifications}
                count={this.props.alerts}
                onClose={this.handleCloseDrawer('notifications')}
            />
        );
    }

    renderSubmenu() {
        const { isMobile } = this.props;
        const { activeMenu, drawer, menus } = this.state;
        const menu = menus.find(e => e.id === activeMenu) || {};
        return (
            <Drawer
                open={drawer}
                position='left'
                width={isMobile ? '100vw' : '500px'}
                className={cls('sidebar', { mobile: isMobile })}
                onClose={this.handleCloseDrawer('drawer')}
                allowDismiss
            >
                <div className='drawer-header'>
                    <button
                        className='btn'
                        onClick={this.handleCloseDrawer('drawer')}
                    >
                        <i className='ms-Icon ms-Icon--ChevronLeft' />
                        {menu.Descripcion}
                    </button>
                </div>
                <ul className='links'>
                    {menu.menusHijos &&
                        menu.menusHijos.map(e => (
                            <li key={e.id}>{this.getLink(e)}</li>
                        ))}
                </ul>
            </Drawer>
        );
    }

    render() {
        const { collapsed, isMobile, isTablet } = this.props;
        const { position, moving } = this.state;
        let sidebarClass = cls('main_sidebar', {
            collapsed: isTablet || (collapsed && !isMobile),
            mobile: isMobile,
            open: position === 0,
            moving: moving
        });
        let sidebarStyle = {
            width: SIDEBAR_WIDTH,
            transform: `translate(${position}px, 0)`
        };
        return (
            <div
                ref={div => (this.sidebar = div)}
                className={sidebarClass}
                style={isMobile ? sidebarStyle : {}}
            >
                {this.renderHeader()}
                {this.renderProfile()}
                {this.renderStatus()}
                {this.renderMenu()}
                {this.renderVersion()}
                {this.renderFooter()}
                {this.renderSubmenu()}
                {this.renderNotifications()}
            </div>
        );
    }
}

export default withSizes(getBreakpoints)(
    connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
